export interface DateFilter {
  start: number
  end: number
}

export enum DateFilterEnum {
  CUR_DAY,
  PREV_DAY,
  PREV_7DAYS,
  CUR_WEEK,
  PREV_WEEK,
  CUR_MONTH,
  PREV_MONTH,
  CUR_YEAR,
  PREV_YEAR,
  CUSTOM,
}
